import PropTypes from 'prop-types';
import {useEffect} from 'react';
import {connect} from 'react-redux';
import cookie from '../../../../cookie';
import {recordBigQueryEvent, setErrorOnPage} from '../../../actions/paymentActions/threedsActions';
import {threeDSecureSuccess} from '../../../actions/site-actions';
import {getSettings} from '../../../selectors/selectors';
import getThreeDSecureData from '../../../selectors/ThreeDSSelectors/getThreeDSecureData';
import Track from '../../../utils/tracking';
import PostToIframe from '../ProviderAgnostic/PostToIframe';
import useStyles from '../ThreeDSecure.styles';

export function Chase3DSChallenge(props) {
  const classes = useStyles();
  
  const THREE_D_SECURE_API_RETURN_URL = `https://${window.location.host}/checkout/3ds-confirmation`;
  const PROVIDER = 'CHASE';
  
  useEffect(() => {
    try {
      recordBigQueryEvent('2ChallengeRequired', PROVIDER);
    } catch (error) {
      Track.track(error);
    }
  }, []);
  
  const handleOnError = () => {
    const errorMessage = 'Error loading Chase 3DS Challenge frame';
    Track.track(new Error(errorMessage));
    props.setErrorOnPage();
    try {
      recordBigQueryEvent('2ChallengeCompleted', PROVIDER,
        [{name: 'result', value: 'error'}], [{type: 'loading', value: errorMessage}]);
    } catch (error) {
      Track.track(error);
    }
  };
  
  const handleOnLoad = (event) => {
    try {
      const mdValue = props.use3dsSessionId ? props.threeDSecureData?.sessionId : cookie.session();
      const loadedURL = event.target.contentWindow.location.href;
      // This only works once the user has returned to our site,
      // otherwise cross-origin error is thrown.
      const THREE_D_SECURE_API_RETURN_URL_WITH_MD = `https://${window.location.host}/checkout/3ds-confirmation?MD=${mdValue}`;
      if (loadedURL === THREE_D_SECURE_API_RETURN_URL || loadedURL === THREE_D_SECURE_API_RETURN_URL_WITH_MD) {
        props.threeDSecureSuccess();
        try {
          recordBigQueryEvent('2ChallengeCompleted', PROVIDER, [{name: 'result', value: 'success'}]);
        } catch (error) {
          Track.track(error);
        }
      } else {
        try {
          recordBigQueryEvent('2ChallengeInitiated', PROVIDER);
        } catch (error) {
          Track.track(error);
        }
      }
    } catch (exception) {
      // Couldn't determine iframe's location, likely because it's still on the bank's domain.
      try {
        recordBigQueryEvent('2ChallengeInitiated', PROVIDER);
      } catch (error) {
        Track.track(error);
      }
    }
  };
  
  return (
    <div className={classes.ThreeDSecureContainer} data-test="Chase3DSChallenge">
      <PostToIframe
        postURL={props.issuerURL}
        formFields={{
          creq: props.oneTime3DSToken,
        }}
        onError={handleOnError}
        onLoad={handleOnLoad}
      />
    </div>
  );
}

Chase3DSChallenge.propTypes = {
  oneTime3DSToken: PropTypes.string.isRequired,
  issuerURL: PropTypes.string.isRequired,
  setErrorOnPage: PropTypes.func.isRequired,
  threeDSecureSuccess: PropTypes.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  threeDSecureData: PropTypes.object,
  use3dsSessionId: PropTypes.bool,
};

const mapStateToProps = state => ({
  threeDSecureData: getThreeDSecureData(state),
  use3dsSessionId: getSettings(state)?.use_3ds_session_id,
});

export default connect(mapStateToProps, {setErrorOnPage, threeDSecureSuccess})(Chase3DSChallenge);
